import React from 'react'
import { DashboardImageCard, IDashboardImageCardProps } from './DashboardImageCard'

interface IDashboardCardsProps {
  cards: IDashboardImageCardProps[]
}

export const DashboardImageCards = ({ cards }: IDashboardCardsProps) => (
  <>
    {cards.map((props) => (
      <DashboardImageCard key={props.title} {...props} />
    ))}
  </>
)
